import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';

import { ApplicationApprovalErrorMessages } from '../common/ApplicationApprovalErrorMessages';
import { DialogTitleWithClose } from '../common/DialogTitleWithClose';

export default function GrowthAwardErrorModal({
  open,
  onClose,
  errorMessages,
}: {
  open: boolean;
  onClose: () => void;
  errorMessages: string[];
}) {
  const handleModalClose = () => {
    if (onClose) onClose();
  };

  return (
    <Dialog open={open} onClose={handleModalClose}>
      <DialogTitleWithClose onClose={handleModalClose}>Approval Error</DialogTitleWithClose>
      <DialogContent>
        <ApplicationApprovalErrorMessages errorMessages={errorMessages} />
      </DialogContent>
      <DialogActions>
        <Button type='button' variant='secondary' size='large' onClick={handleModalClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
